import React from "react"
import {Col, Form, Row} from "react-bootstrap";
import {getFieldLabel, getOperatorLabel, getValueLabel} from "../../utils/labelUtils";

const ConditionGroupRenderer = ({ group, t }: { group: ConditionGroup, t:any }) => {
    return (
        <div style={{ paddingLeft: 12, marginBottom: 12 }}>
            {group.conditions.map((cond, idx) => {
                const isLast = idx === group.conditions.length - 1;

                return (
                    <div key={idx}>
                        {"field" in cond ? (
                            <ConditionRow condition={cond} t={t} />
                        ) : (
                            <div style={{ borderLeft: "2px dashed #ccc", marginLeft: 10, paddingLeft: 10 }}>
                                <ConditionGroupRenderer group={cond} t={t} />
                            </div>
                        )}
                        {!isLast && (
                            <div style={{ textAlign: "center", margin: "8px 0", fontWeight: "bold" }}>
                                {getOperatorLabel(t,group.join)}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}



const ConditionRow = ({ condition, t }: { condition: Condition ,t:any }) => (
    <Row>
        <Col md={4}>
            <Form.Control value={getFieldLabel(t,condition.field)} disabled/>
        </Col>
        <Col md={4}>
            <Form.Control value={getOperatorLabel(t,condition.operator)} disabled/>
        </Col>
        <Col md={4}>
            <Form.Control value={getValueLabel(t,condition.value)} disabled/>
        </Col>
    </Row>
);
export default ConditionGroupRenderer